import { useMemo } from 'react';

import {
  getContract as getContractViem,
  type Abi,
  type Address as AddressType,
} from 'viem';
import { clientWallet, publicWallet } from '../libs/viem/config';

export const getContract = ({
  contractAddress,
  ABI,
}: {
  contractAddress: AddressType;
  ABI: any;
}) => {
  //@ts-ignore
  return getContractViem({
    address: contractAddress,
    abi: ABI as unknown as Abi,
    client: { public: publicWallet, wallet: clientWallet },
  }) as unknown as any;
};

export const useContractViem = (
  contractAddress: AddressType | null,
  ABI: any
) => {
  return useMemo(() => {
    if (!contractAddress || !ABI) return null;
    try {
      return getContract({ contractAddress, ABI });
    } catch (error) {
      console.error('Failed to get contract', error);
      return null;
    }
  }, [contractAddress, ABI]);
};
